import { useState } from 'react';
import { FlatList, StyleSheet, TouchableOpacity, View } from 'react-native';

import Text from '../Text';

export declare const CountryCodeList: readonly [
  'AF',
  'AL',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BA',
  'BW',
  'BV',
  'BR',
  'IO',
  'VG',
  'BN',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'CA',
  'CV',
  'BQ',
  'KY',
  'CF',
  'TD',
  'CL',
  'CN',
  'CX',
  'CC',
  'CO',
  'KM',
  'CK',
  'CR',
  'HR',
  'CU',
  'CW',
  'CY',
  'CZ',
  'CD',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'SZ',
  'ET',
  'FK',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'TF',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GI',
  'GR',
  'GL',
  'GD',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HM',
  'HN',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IM',
  'IL',
  'IT',
  'CI',
  'JM',
  'JP',
  'JE',
  'JO',
  'KZ',
  'KE',
  'XK',
  'KW',
  'KG',
  'LA',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MO',
  'MK',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MA',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NL',
  'NC',
  'NZ',
  'NI',
  'NE',
  'NG',
  'NU',
  'NF',
  'KP',
  'MP',
  'NO',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PN',
  'PL',
  'PT',
  'PR',
  'QA',
  'CG',
  'RO',
  'RU',
  'RW',
  'RE',
  'BL',
  'SH',
  'KN',
  'LC',
  'MF',
  'PM',
  'VC',
  'WS',
  'SM',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SX',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'GS',
  'KR',
  'SS',
  'ES',
  'LK',
  'SD',
  'SR',
  'SJ',
  'SE',
  'CH',
  'SY',
  'ST',
  'TW',
  'TJ',
  'TZ',
  'TH',
  'TL',
  'TG',
  'TK',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'US',
  'UM',
  'VI',
  'UY',
  'UZ',
  'VU',
  'VA',
  'VE',
  'VN',
  'WF',
  'EH',
  'YE',
  'ZM',
  'ZW',
  'KI',
  'HK',
  'AX'
];
export declare type CountryCode = (typeof CountryCodeList)[number];

type CountryCodeItem = {
  code: CountryCode;
  number: string;
  emoji: string;
};

const CountryCodes: CountryCodeItem[] = [
  {
    code: 'US',
    number: '+1',
    emoji: '🇺🇸'
  },
  { code: 'AR', number: '+54', emoji: '🇦🇷' }
];

interface CustomCountryPickerProps {
  variant?: 'default' | 'rounded_with_shadow' | 'small_border_radius';
  setCountryCode: (countryCode: CountryCode) => void;
}

const CustomCountryPicker = ({ variant = 'default', setCountryCode }: CustomCountryPickerProps) => {
  const [currentCC, setCC] = useState<CountryCodeItem>(CountryCodes.at(0)!);
  const [showCountriesList, setShowCountriesList] = useState<boolean>(false);

  return (
    <View style={[{ height: variant === 'default' ? 52 : 40 }, styles.pickerButton, styles.contentStyle]}>
      <TouchableOpacity style={styles.countryItem} onPress={() => setShowCountriesList((prev) => !prev)}>
        <Text style={styles.textItem}>{currentCC.emoji}</Text>
        <Text style={[styles.countryNumber, styles.textItem]}>{currentCC.number}</Text>
      </TouchableOpacity>

      {showCountriesList && (
        <FlatList
          data={CountryCodes}
          style={styles.countriesList}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.contentStyle}
          renderItem={({ item }) => (
            <TouchableOpacity
              onPress={() => {
                setCC(item);
                setCountryCode(item.code);
                setShowCountriesList(false);
              }}
              key={item.code}
              style={styles.countryItem}>
              <Text style={styles.textItem}>{item.emoji}</Text>
              <Text style={[styles.countryNumber, styles.textItem]}>{item.number}</Text>
            </TouchableOpacity>
          )}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  countriesList: {
    position: 'absolute',
    top: 50,
    left: 0,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#ccc',
    zIndex: 1000,
    width: '100%',
    borderRadius: 8
  },

  pickerButton: {
    backgroundColor: 'white',
    borderColor: '#000',
    borderRadius: 8,
    borderWidth: 1,
    paddingHorizontal: 5,
    marginRight: 10,
    width: 80,
    position: 'relative',
    overflow: 'visible'
  },

  contentStyle: {
    justifyContent: 'center'
  },

  countryNumber: {
    color: 'black'
  },

  countryItem: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: 53
  },

  textItem: {
    fontSize: 18
  }
});

export default CustomCountryPicker;
